import React from 'react';
import PropTypes from 'prop-types';

const WaterPoloPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M21.477 27.643a12.457 12.457 0 0 1-4.369 1.196c-.316.093-.68.15-1.108.15-.427 0-.792-.057-1.108-.15a12.456 12.456 0 0 1-4.369-1.196 7.89 7.89 0 0 0-.369.288c-.582.472-1.304 1.058-2.676 1.058S5.383 28.403 4.8 27.93c-.497-.404-1.04-.671-1.801-.671v-1.73c1.372 0 2.311.587 2.893 1.059.497.403.824.67 1.585.67.679 0 1.015-.215 1.437-.551-3.25-2.233-5.358-5.978-5.358-10.265C3.557 9.51 9.07 4 16 4c6.93 0 12.443 5.51 12.443 12.443 0 4.289-2.109 8.032-5.358 10.265.422.336.758.552 1.437.552.756 0 1.088-.268 1.585-.671.582-.472 1.52-1.058 2.893-1.058v1.729c-.76 0-1.304.267-1.801.671-.582.472-1.305 1.058-2.677 1.058s-2.094-.586-2.676-1.058a7.887 7.887 0 0 0-.37-.288zm5.335-11.204c0 .612-.05 1.211-.144 1.797-.022-.021-.034-.042-.06-.063-.748-.553-3.326-2.617-4.546-3.225.136-1.457.158-6.334-5.191-9.283 5.637.43 9.941 5.005 9.941 10.774M15.252 5.657c.553.28 1.19.671 1.836 1.19-1.492.518-7.732 3.19-11.85 8.568.477-5.319 4.653-9.406 10.014-9.758M5.21 17.102c1.487-2.001 7.354-7.932 12.817-9.41 1.504 1.508 2.851 3.734 3.034 6.87-5.952 3.177-10.205 9.112-11.182 10.956-2.685-1.86-4.465-4.92-4.669-8.416m5.701 9.049a25.607 25.607 0 0 1 2.426-3.526c1.245 1.776 3.68 3.738 5.081 4.529-.773.174-1.58.271-2.413.271a10.751 10.751 0 0 1-5.094-1.274zm8.99.548a.342.342 0 0 0-.166-.204c-2.345-.986-4.618-3.535-5.582-4.826 2.957-3.31 6.054-5.234 6.942-5.76.034-.022.06-.04.093-.06.965.53 4.002 2.574 5.107 3.853.021-.03.042-.064.064-.094-.948 3.259-3.335 5.88-6.458 7.091z"
    />
  );
};

WaterPoloPath.propTypes = {
  fill: PropTypes.string,
};

export default WaterPoloPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/water-polo.jsx